import store from '../store';

export default {
    data() {
        return {
            loadingOrderSummary: false,
            shippingMethodName: null,
            applyingCoupon: false,
            couponCode: null,
            couponError: null,
            costExtra: 0,
            isBand: false,
            isSpecial: false
        };
    },

    computed: {
        cart() {
            return store.state.cart;
        },

        cartIsEmpty() {
            return store.cartIsEmpty();
        },

        cartIsNotEmpty() {
            return !store.cartIsEmpty();
        },

        hasShippingMethod() {
            return store.hasShippingMethod();
        },

        firstShippingMethod() {
            return Object.keys(store.state.cart.availableShippingMethods)[0];
        },

        hasCoupon() {
            return store.state.cart.coupon.code !== undefined;
        },

        hasSpecialProduct() {
            var items = Object.values(store.state.cart.items);
   
            return items.some(function(el) {
                return el.product.is_special;
            });
        },

        hasOptionBand() {
            var items = Object.values(store.state.cart.items).filter(item => item.product.is_special);

            if(items.length > 0) {
                this.isSpecial = true;
                items.forEach(e => {
                    Object.values(e.options).forEach(option => {
                        this.isBand = option.values.some(function(el) {
                            return el.label == 'Band';
                        });
                    });
                });
            }

            return  this.isBand;
        }
    },

    methods: {
        applyCoupon() {
            if (!this.couponCode) {
                return;
            }

            this.loadingOrderSummary = true;
            this.applyingCoupon = true;

            $.ajax({
                method: 'POST',
                url: route('cart.coupon.store', {
                    coupon: this.couponCode
                }),
            }).then((cart) => {
                this.couponCode = null;

                store.updateCart(cart);
            }).catch((xhr) => {
                this.couponError = xhr.responseJSON.message;
            }).always(() => {
                this.loadingOrderSummary = false;
                this.applyingCoupon = false;
            });
        },

        removeCoupon() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'DELETE',
                url: route('cart.coupon.destroy'),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        updateShippingMethod(shippingMethod) {
            if (typeof shippingMethod === 'string') {
                shippingMethod = {
                    name: shippingMethod
                };
            } else {
                this.loadingOrderSummary = true;
            }

            this.changeShippingMethod(shippingMethod);

            $.ajax({
                method: 'POST',
                url: route('cart.shipping_method.store', {
                    shipping_method: shippingMethod.name,
                    costExtra: this.costExtra
                }),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        updateFreeAfterChangeAddress(shippingMethod) {
            if (typeof shippingMethod === 'string') {
                shippingMethod = {
                    name: shippingMethod
                };
            } else {
                this.loadingOrderSummary = true;
            }

            $.ajax({
                method: 'POST',
                url: route('cart.shipping_method.store', {
                    shipping_method: shippingMethod.name,
                    costExtra: this.costExtra
                }),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },
    },
};
